
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindShaft13 as ObiWindShaft13Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-shaft-13.js';
 
 
 

 
 export const ObiWindShaft13 = createComponent({
   react: React,
   tagName: 'obi-wind-shaft-13',
   elementClass: ObiWindShaft13Element,
   events: {
     
   }
  });
 
 